/* ////////////////////////// */
/* Customise Navigation */
/* ////////////////////////// */

var undefined;
var shp = '';

$(function() {
	setTimer();
  // if (cart) initialize instruction textarea
	initializeNote();
  // if (product)
	checkCartItems("product");
});

var Timer;
//var Timer2;				//for reset top-collection urls

function setTimer() {
	Timer = setTimeout(check_shp,500);
}

//check and set shop//////////////////////////////////////////////////////////////////////////////////////////////////
function check_shp() {
	if ($.url().param("shp") === "" || $.url().param("shp") === undefined) {
		//shp = "Paseo";
		if (getCookie() === "" || getCookie() === undefined) {
			shp = "Paseo";
		}
		else {
			shp = getCookie();
		}
	}
	else {
		shp = $.url().param("shp");
		setCookie(shp) ;
	}
	
	//var mnu = $("#nav_list li a");
	$("#nav_list li").each(function() {
		if ($(this).html().match(shp)) {
			//
		}
		else {
			$(this).css("display","none");
		}
	})
	
	clearTimeout(Timer);
    //Timer2 = setTimeout(rewite_clctnurls,1000);
}


//set & get Cookie///////////////////////////////////////////////////////////////////////////////////////////////////
//Constant and Variables -------------------------------------------
var CMN = {};
CMN.SHOP_NAME = 'shopname';
//CMN.DOMAIN = 'inters-shop.myshopify.com';	//varies by site domain
CMN.DOMAIN = 'hana-fusui.paseo-freemarket.co.jp';	//varies by site domain
CMN.PATH = '/';
CMN.MAXAGE = 60 * 60;
CMN.EXPDAYS = 1;

//Set Cookie Values
function setCookie(val) {
	dat = val;
	exp = new Date();
	exp.setTime(exp.getTime()+ (CMN.EXPDAYS * 1000 * 60 * 60 * 24));
	exp2 = exp.toGMTString();
	cstr = CMN.SHOP_NAME + '=' + escape(dat) + ';';
	cstr = cstr + ' domain=' + CMN.DOMAIN + ';';
	cstr = cstr + ' path=' + CMN.PATH + ';';
	cstr = cstr + ' max-age=' + CMN.MAXAGE + ';';
	cstr = cstr + ' expires=' + exp2;
	document.cookie = cstr;
}

//Cookie の設定値を返す
function getCookie() {
	var c_name = CMN.SHOP_NAME;
	var i, x, y, ARRcookies = document.cookie.split(';');
	for (var i = 0; i<ARRcookies.length; i++) {
		x = ARRcookies[i].substr(0,ARRcookies[i].indexOf('='));
		y = ARRcookies[i].substr(ARRcookies[i].indexOf('=')+1);
		x = x.replace(/^¥s+|¥s+$/g,'');
		if (x.match(c_name)){
			return unescape(y);
		}
	}
}


/* ////////////////////////////////// */
/* kantei info form */
/* ////////////////////////////////// */
// set year month date for birth date / k_year k_month k_day /////////////////////////////////////////////
var yyyy;
var last_yyyy;
var last_d;

var k_yyyy;
var k_last_d;

// set birth day /////////////////////////////////////////////////////////////////////
function set_yearlist() {
	yyyy = new Date().getFullYear();
	last_yyyy = yyyy - 110;
	var opt_y = '<option value="">年を選択してください</option>';
	for (i=0; i<110; i++) {
		opt_y += '<option value="' + (yyyy - i) + '">' + (yyyy - i) + '</option>';
	}
	$("#year").append(opt_y);
}

function set_monthlist() {
	var opt_m = '<option value="">月を選択してください</option>';
	for (i=1; i<=12; i++) {
		opt_m += '<option value="' + i + '">' + i + '</option>';
	}
	$("#month").html(opt_m);
}

function set_datelist() {
	var y = '';
	var m = '';
	var opt_d = '<option value="">日を選択してください</option>';
	
	y = document.kantei_form.year.value;
	m = document.kantei_form.month.value;
	if (y === '' || y === undefined) {  }
	else {
		if (m === '' || m === undefined) {  }
		else {
			last_d = new Date(y,m,0).getDate();
			for (i=1; i<=last_d; i++) {
				opt_d += '<option value="' + i + '">' + i + '</option>';
			}
			$("#day").html(opt_d);
		}
	}
}

// set k date ///////////////////////////////////////////////////////////////////////////
function set_kyearlist() {
	k_yyyy = new Date().getFullYear();
	
	var opt_y = '<option value="">年を選択してください</option>';
	for (i=0; i<10; i++) {
		opt_y += '<option value="' + (k_yyyy + i) + '">' +  (k_yyyy + i) + '</option>';
	}
	
	$("#k_year").html(opt_y);
}

function set_kmonthlist() {
	var opt_m = '<option value="">月を選択してください</option>';
	for (i=1; i<=12; i++) {
		opt_m += '<option value="' + i + '">' + i + '</option>';
	}
	
	$("#k_month").html(opt_m);
}

function set_kdatelist() {
	var y = '';
	var m = '';
	var opt_d = '<option value="">日を選択してください</option>';
	
	y = document.kantei_form.k_year.value;
	m = document.kantei_form.k_month.value;
	if (y === '' || y === undefined) {  }
	else {
		if (m === '' || m === undefined) {  }
		else {
			k_last_d = new Date(y,m,0).getDate();
			for (i=1; i<=k_last_d; i++) {
				opt_d += '<option value="' + i + '">' + i + '</option>';
			}
			
			$("#k_day").html(opt_d);
		}
	}
}


function setOneYear() {
	var alt_txt_init = "";
	if (document.kantei_form.k_year.value === "" || document.kantei_form.k_year.value === undefined) {
		alt_txt_init += "運気をあげたい期間開始の年を入力してください。\n";
	}
	if (document.kantei_form.k_month.value === "" || document.kantei_form.k_month.value === undefined) {
		alt_txt_init += "運気をあげたい期間開始の月を入力してください。\n";
	}
	if (document.kantei_form.k_day.value === "" || document.kantei_form.k_day.value === undefined) {
		alt_txt_init += "運気をあげたい期間開始の日を入力してください。\n";
	}
	
	if (alt_txt_init === "") {
		var alt_txt = "";
		var y = document.kantei_form.k_year.value;
		var m = document.kantei_form.k_month.value;
		var d = document.kantei_form.k_day.value;
		//check k_year
		if (y.match(/^[0-9]+$/)) {  }
		else { alt_txt += "運気をあげたい期間開始の年に半角数字ではないものが含まれています。すべて半角数字でお願いします。\n"; }
		//check k_month
		if (m.match(/^[0-9]+$/)) {  }
		else { alt_txt += "運気をあげたい期間開始の月に半角数字ではないものが含まれています。すべて半角数字でお願いします。\n"; }
		//check k_day
		if (d.match(/^[0-9]+$/)) {  }
		else { alt_txt += "運気をあげたい期間開始の月に半角数字ではないものが含まれています。すべて半角数字でお願いします。\n"; }
	
		if (alt_txt === "") {
			var lmtTo = new Date(parseInt(y),parseInt(m)-1,parseInt(d));
			lmtTo.setFullYear(lmtTo.getFullYear() + 1);
			lmtTo.setDate(lmtTo.getDate() - 1);
		
			var lmt_yTo = String(lmtTo.getFullYear());
			var lmt_mTo = String(lmtTo.getMonth() + 1);
			var lmt_dTo = String(lmtTo.getDate());
			
			document.kantei_form.k_yaer_to.value = lmt_yTo;
			document.kantei_form.k_month_to.value = lmt_mTo;
			document.kantei_form.k_day_to.value = lmt_dTo;
		}
		else {
			alert(alt_txt);
		}
	}
	else {
		alert(alt_txt_init);
	}
}


// set w day /////////////////////////////////////////////////////////////////////
function reset_wd() {
	document.kantei_form.w_day.value = "";
}


// get & set kantei_ query ////////////////////////////////////////////////////////
var nam_r;	var by;	var bm;	var bd; var gndr; var ky_a; var km_a; var kd_a; var ky_b; var km_b; var kd_b; var wd; var unk; var nam_s; var crd; var rqst;

var now = new Date().getTime();

//revd @20210826 yyyy比較 >> getTime比較
/*var yyyy_sp_f = false;		//accept year in the future
var yyyy_sp_p = false;		//accept year in the past*/
var accept_b_f = false;			//生年月日の未来日付を受け入れる
var accept_b_p = false;			//生年月日が110年以上前を受け入れる
var accept_kb_p = false;				//運気をあげたい期間の最終日が過去を受け入れる

var show_dialog_f = false;	//show dialog for b_f
var show_dialog_p = false;	//show dialog for b_p
var show_dialog_k = false;	//show dialog for k_b

function Alert() {
	nam_r = document.kantei_form.name.value;
	by = document.kantei_form.year.value;
	bm = document.kantei_form.month.value;
	bd = document.kantei_form.day.value;
	//性別
	for (z=0; z<document.kantei_form.gender.length; z++) {
		if (document.kantei_form.gender[z].checked) {
			gndr = document.kantei_form.gender[z].value;
		}
	}
	//期間開始
	ky_a = document.kantei_form.k_year.value;
	km_a = document.kantei_form.k_month.value;
	kd_a = document.kantei_form.k_day.value;
	
	//期間終了日（自動計算により以下のinputに代入されている）
	ky_b = document.kantei_form.k_yaer_to.value;
	km_b = document.kantei_form.k_month_to.value;
	kd_b = document.kantei_form.k_day_to.value;
	
	//用途
	wd = document.kantei_form.w_day.value;
	
	//メッセージカード
	crd = document.kantei_form.mssg_card.value;
	
	//運気
	for (y=0; y<document.kantei_form.unki.length; y++) {
		if (document.kantei_form.unki[y].checked) {
			unk = document.kantei_form.unki[y].value;
		}
	}
	nam_s = document.kantei_form.name_snd.value;
	
	//↓add @00605 ストアへの要望事項追加
	rqst = document.kantei_form.rqst.value;
	//↑add @00605 ストアへの要望事項追加
	
	var alert_txt = '';
	//name received
	if (nam_r === '' || nam_r === undefined) { alert_txt += '贈り先様のお名前を入力してください。\n'; }
	
	//year
	if (by === '' || by === undefined) {
		alert_txt += '生年月日の年を選択または入力してください。\n';
	}
	else {
		if (by.match(/^[0-9]+$/)) {
			if (checkDigits(by,4)) { }
			else {
				alert_txt += '生年月日の年が5桁以上になっています。\n';	
			}
		}
		else {
			alert_txt += "生年月日の年に半角数字でないものがあるようです。すべて半角数字でお願いします。\n";
		}
	}
	//month
	if (bm === '' || bm === undefined) {
		alert_txt += '生年月日の月を選択または入力してください。\n';
	}
	else {
		if (bm.match(/^[0-9]+$/)) {
			//0を除く
			bm = delete0(bm);

			if (checkDigits(bm,2)) {
				if(parseInt(bm) < 1 || 12 < parseInt(bm)) {
					alert_txt += '生年月日の月があり得ない月になっています。\n';
				}
			}
			else {
				alert_txt += '生年月日の月が3桁以上になっています。\n';	
			}
		}
		else {
			alert_txt += "生年月日の月に半角数字でないものがあります。すべて半角数字でお願いします。\n";
		}
	}
	//day
	if (bd === '' || bd === undefined) {
		alert_txt += '生年月日の日を選択または入力してください。\n';
	}
	else {
		if (bd.match(/^[0-9]+$/)) {
			//0を除く
			bd = delete0(bd);

			if (checkDigits(bd,2)) {
				var dy_lst = new Date(by,bm,0).getDate();
				if (parseInt(bd) < 1 || parseInt(bd) > dy_lst) {
					alert_txt += '生年月日の日があり得ない日付になっています。\n';
				}	
			}
			else {
				alert_txt += '生年月日の日が3桁以上になっています。\n';	
			}
		}
		else {
			alert_txt += "生年月日の日に半角数字でないものがあります。すべて半角数字でお願いします。\n";
		}
	}
	
	//check birth day - future or past by 110 or more
	var birthGT = new Date(parseInt(by),parseInt(bm)-1,parseInt(bd)).getTime();
	var lmt_p = new Date(last_yyyy,parseInt(bm)-1,parseInt(bd)).getTime();
	if (now < birthGT && accept_b_f === false) {
		show_dialog_f = true;
	}
	else {
		show_dialog_f = false;
	}
	if (birthGT < lmt_p && accept_b_p === false) {
		show_dialog_p = true;
	}
	else {
		show_dialog_p = false;
	}
	
	//gender
	if (gndr === '' || gndr === undefined) { alert_txt += '贈り先の方の性別を選択してください。\n' }
	
	//kyear_a
	if (ky_a === "" || ky_a === undefined) { alert_txt += '運気を上げたい期間開始日の年を選択または入力してください。\n' }
	else {
		if (ky_a.match(/^[0-9]+$/)) {
			if (checkDigits(ky_a,4)) { }
			else {
				alert_txt += '運気を上げたい期間開始日の年が5桁以上になっています。\n';	
			}
		}
		else {
			alert_txt += "運気を上げたい期間開始日の年に半角数字でないものがあります。すべて半角数字でお願いします。\n";
		}
	}
	//kmonth_a
	if (km_a === '' || km_a === undefined) {
		alert_txt += '運気を上げたい期間開始日の月を選択または入力してください。\n';
	}
	else {
		if (km_a.match(/^[0-9]+$/)) {
			//0を除く
			km_a = delete0(km_a);
			if (checkDigits(km_a,2)) {
				if(parseInt(km_a) < 1 || 12 < parseInt(km_a)) {
					alert_txt += '運気を上げたい期間開始日の月があり得ない月になっています。\n';
				}
			}
			else {
				alert_txt += '運気を上げたい期間開始日の月が3桁以上になっています。\n';	
			}
		}
		else {
			alert_txt += "運気を上げたい期間開始日の月に半角数字でないものがあります。すべて半角数字でお願いします。\n";
		}
	}
	//kday_a
	if (kd_a === '' || kd_a === undefined) {
		alert_txt += '運気を上げたい期間開始日の日を選択または入力してください。\n';
	}
	else {
		if (kd_a.match(/^[0-9]+$/)) {
			//0を除く
			kd_a = delete0(kd_a);

			if (checkDigits(kd_a,2)) {
				var kdya_lst = new Date(ky_a,km_a,0).getDate();
				if (parseInt(kd_a) < 1 || parseInt(kd_a) > kdya_lst) {
					alert_txt += '運気を上げたい期間開始日の日があり得ない日付になっています。\n';
				}	
			}
			else {
				alert_txt += '運気を上げたい期間開始日の日が3桁以上になっています。\n';	
			}
		}
		else {
			alert_txt += "運気を上げたい期間開始日の日に半角数字でないものがあります。すべて半角数字でお願いします。\n";
		}
	}
	
	//check day to / past or not
	var dayToGT = new Date(parseInt(ky_b),parseInt(km_b)-1,parseInt(kd_b));
	if (dayToGT < now && accept_kb_p === false) {
		show_dialog_k = true;
	}
	else {
		show_dialog_k = false;
	}
	
	//用途
	if (wd === "" || wd === undefined) {
		alert_txt += 'ご利用の用途を選択または入力してください。\n';
	}
	
	//mssg_card
	if (crd === "" || crd === undefined) {
		alert_txt += 'メッセージカードを選択してくだい。\n';
	}
	
	//unki
	if (unk ===  "" || unk === undefined) {
		alert_txt += '上げたい運気を選択してください。\n';
	}
	//sender's name
	if (nam_s ===  "" || nam_s === undefined) {
		alert_txt += '贈り主様のお名前を入力してください。\n';
	}
	
	//alert or set kantei info text
	if (alert_txt === '' || alert_txt === undefined) {
		if (show_dialog_f === true) {
			alert_year_sp("f");
		}
		else if (show_dialog_p === true) {
			alert_year_sp("p");
		}
		else if (show_dialog_k === true) {
			alert_k_so();
		}
		else {
			var rqst_txt = ""
			if (rqst === "" || rqst === undefined) {  }
			else {
				rqst_txt = '////以下「ストアへのご要望・ご連絡事項」です////\n' + rqst;
			}
			//set kantei info text
			var info_txt = '贈り先様のお名前：' + nam_r + '\n' +
							//'生年月日：' + intYr + '年' + intMn + '月' + intDy + '日\n' +
							'生年月日：' + by + '年' + bm + '月' + bd + '日\n' +
			　　　			'贈り先様の性別：' + gndr + '\n' +
							'運気を上げたい期間の開始日：' + ky_a + '年' + km_a + '月' + kd_a + '日\n' +
							/*'期間：' + prd + '\n' +*/
							'運気を上げたい期間の最終日：' + ky_b + '年' + km_b + '月' + kd_b + '日\n' +
							'用途：' + wd + '\n' +
							'メッセージカード：' + crd + '\n' +
							'上げたい運気：' + unk + '\n' +
							'贈り主様のお名前：' + nam_s + '\n' +
							//↓revd @20220605 ストアへの要望事項追加
							//'以上';
							'以上\n\n' +
							rqst_txt;
							//↑revd @20220605 ストアへの要望事項追加
							
			$("#CartSpecialInstructions").val(info_txt);
            //revd add @20220702　buybuttonを書き換え
            setBuybtn();
		}
	}
	else {
		alert(alert_txt);
	}
}


// common functions //////////////////////////////////////////////////////////////////////////
// TXT to Integer ///////////////////////////////////////////////////////
/*function toInteger(TXT) {
	var num;
	
	val = TXT.toString();
    // 全角を半角に変換（ハイフン、ドット、数字以外を取り除く）
    num = TXT.replace(/[０-９．‐－]/g, function (s) {
        return String.fromCharCode(s.charCodeAt(0) - 65248);
    }).replace(/(?!^\-)[^\d\.]/g, "");

    // 整数に変換
    num = parseInt(num, 10);

    // 整数にパース出来なかったときは0を返す
    return isNaN(num) ? "NAN" : num;
}*/

// check no of digits ////////////////////////////////////////////////////
function checkDigits(TXT,NO) {
	var bln = true;
	if (NO < TXT.length) {
		bln = false;
	}
	return bln; 
}

// delete "0" @(0) ///////////////////////////////////////////////////////
function delete0(NO) {
	var no = NO.toString();
	if (NO.length === 2 && (NO.charAt(0) === 0 || NO.charAt(0) === "0")) {
		no = parseInt(NO.charAt(1));
	}
	else {
		no = parseInt(NO);
	}
	return no;
}


// set yyyy special ///////////////////////////////////////////////////////
function alert_year_sp(TXT) {
	if (TXT === "f") {
		var txt = '生年月日が来年以降の未来日付ですが、よろしいですか？';
		var y_sp = confirm(txt);
		if (y_sp === true) {
			accept_b_f = true;
			Alert();
		}
		else {
			alert('生年月日の年を正しく入力してください。');
		}
	}
	else if (TXT === "p") {
		var txt = '生年月日が110年以上前の日付ですが、よろしいですか？';
		var y_sp = confirm(txt);
		if (y_sp === true) {
			accept_b_p = true;
			Alert();
		}
		else {
			alert('生年月日の年を正しく入力してください。');
		}
	}
}

function alert_k_so() {
	var txt = "運気をあげたい期間が過去になっていますが、よろしいですか？";
	var k_sp = confirm(txt);
	if (k_sp === true) {
		accept_kb_p = true;
		Alert();
	}
	else {
		alert("運気をあげたい期間を修正してください。");
	}
}

// revd @20220605 「キャンセル」Dialogを表示
function alertCancel() {
	var txt = "入力をすべてクリアします。よろしいですか？";
	var goCncl = confirm(txt);
	if (goCncl === true) {
		document.kantei_form.reset();
		//誕生日、期間開始日時の月・日をクリア
		$("#month").html("");
		$("#day").html("");
		$("#k_year").html("");
		$("#k_month").html("");
		$("#k_day").html("");
	}
	else {
		return false;
	}
}


/* ////////////////////////////////// */
/* set delivery date part */
/* ////////////////////////////////// */
//配達可能日の設定
function setDatDelivery() {
	var lmt = new Date();
	//lmt.setMonth(lmt.getMonth() + 1);
	lmt.setDate(lmt.getDate() + 14);
    //lmt.setDate(lmt.getDate() + 21);
	var lmt_y = lmt.getFullYear();
	var lmt_m = lmt.getMonth() + 1;
	var lmt_d = lmt.getDate();
	var lmt_b = getYoubi(lmt.getDay());
	$("#dat_delivery").html(lmt_y + "年" + lmt_m + "月" + lmt_d + "日(" + lmt_b + ")");
}

//曜日コードを曜日テキストに変換
function getYoubi(num)
{
	var youbi = "";
	if(num==0){
		youbi = "日";
	}else if(num==1){
		youbi = "月";
	}else if(num==2){
		youbi = "火";
	}else if(num==3){
		youbi = "水";
	}else if(num==4){
		youbi = "木";
	}else if(num==5){
		youbi = "金";
	}else if(num==6){
		youbi = "土";
	}
	return youbi;
}


/* ////////////////////////////////// */
/* alter buybtn function */
/* ////////////////////////////////// */
function setBuybtn() {
  // ↓MOD@230410 for agree PP
	//var btn_tag = '<button type="submit" name="checkout" class="btn">ご購入手続きへ</button>';
        var btn_tag = '<div style="padding:0 0 20px 0; text-align:left">' +
					'<div style="padding:0 0 10px 0;">' +
						'ご購入いただく前に、個人情報の取り扱いについて以下にご同意をお願いします。ご同意いただければ「購入手続き」へ進んでいただけます。<br>' +
						'<div style="padding:10px 3%; background-color:#efefef;">' +
							'当サイトでは広告の効果測定のため、第三者の運営するツールから当サイトに訪れる前にクリックされている広告の情報(クリック日が広告掲載サイトなど)を取得し、ご注文の情報と称号する場合があります。' +
						'</div>' +
						'<input type="checkbox" name="agree" id="agree_checkbox" onchange="showCheckoutbtn();">　同意します'
					'</div>' +
				'</div>';
  // ↑MOD@230410 for agree PP
	$("#buybtn").html(btn_tag);
}

// ↓ADD@230410 matsushita agree PP
function showCheckoutbtn() {
    if (document.kantei_form.agree.checked) {
		var checkoutbtn_tag = '<button type="submit" name="checkout" class="btn">ご購入手続きへ</button>';
		$("#buybtn").append(checkoutbtn_tag);
	}
}
// ↑ADD@230410 matsushita agree PP

function checkOnBuybtn() {
	if ($("#CartSpecialInstructions").val() === "" || $("#CartSpecialInstructions").val() === undefined) {
		alert("この商品の鑑定情報を左のフォームから入力してください。");
		return false;
	}
  else {
		document.kantei_form.submit();
	}
}

function initializeNote() {		//if (cart) 
	if (document.title.match(/ショッピングカート/)) {
		$("#CartSpecialInstructions").val("");
	}
}


/* ////////////////////////////////// */
/* 商品詳細ページ check count of items in cart / set deliverable date */
/* ////////////////////////////////// */
function checkCartItems(TXT) {
	var isPrd = false;
	var metas = document.getElementsByTagName('meta');
	for (i=0; i<metas.length; i++) {
		if (metas[i].getAttribute("property") === "og:type") {
			var prp = metas[i].getAttribute("content");
			if (prp === TXT) { isPrd = true; }
			break;
		}
	}
	
	if (isPrd) {
		setToCartBtn();
        //配達可能日の設定
		setDatDelivery();
	}
}

function setToCartBtn() {
	$.ajax({
		url:"/cart.js",
    	type:"get",
    	dataType:"json",
    	timeout:8000
	})
	.done (function(data) {
		var mx = 0;
		var crt = data;
		if (mx < parseInt(crt.item_count)) {
			var tag = '<button type="button" name="add" id="AddToCart" class="btn product-single__cart-submit">' +
                		'<span id="AddToCartText">カートには既に商品があります</span>'
              		'</button>';
			$("#toCartBtn").html(tag);
		}
	})
	.fail (function() {
		//alert("er");
	})
}


/* ////////////////////////////////// */
/* Toppge rewite collection urls */
/* ////////////////////////////////// */
/*
function setPrdctUrl() {
  alert("setPrdctUrl");
	//added20220314
	var shp_dst = '';
	if ($.url().param("shp") === "" || $.url().param("shp") === undefined) {
		if (getCookie() === "" || getCookie() === undefined) {
			//delete@20220314
          	//shp_dst = "";
		}
		else {
			shp_dst = getCookie();
		}
	}
	else {
		shp_dst = $.url().param("shp");
	}
  
  	if (shp_dst === "" || shp_dst === undefined || shp_dst === "Paseo") {  }
	else {
		//for each replace URL
		$(".featured_products").find("a").each(function() {
			var URL = $(this).attr("href") + '-' + shp_dst;
			$(this).attr("href",URL);
		})
	}
}

function rewite_clctnurls() {
  alert("rewite_clctnurls")
	if ($("body").attr("id") === "花-x-風水-で幸運を贈るフラワーギフト") {
		setPrdctUrl();
	}
	clearTimeout(Timer2);
}
*/